<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title> GL Account No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-flex xs12>
            <form>
               <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> Filters
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row>
                          <v-flex xs6>
                            <v-text-field v-model="filters.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" v-validate="'max:4'"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field v-model="filters.glacctNo" :label="labels.glacctNo" :error-messages="errors.collect('glacctNo')" data-vv-name="glacctNo" :data-vv-as="labels.glacctNo" v-validate="'max:16'"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs6>
                            <v-text-field v-model="filters.fund" :label="labels.fund" :error-messages="errors.collect('fund')" data-vv-name="fund" :data-vv-as="labels.fund" v-validate="'max:4'"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field v-model="filters.acctNoSfx" :label="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx" v-validate="'max:4'"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs6>
                            <v-text-field v-model="filters.description" :label="labels.description" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'max:60'"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
        </v-expansion-panels>
            </form>
          </v-flex>
        </v-card>
        <v-spacer class="mt-2"></v-spacer>
        <v-card>
          <!-- <V-card-title>
            <div class="headline">GL Account No. Listing</div>
          </V-card-title> -->
          <v-card-text>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{row.item.branch}}</td>
                <td class="text-xs-left">{{row.item.glacctNo}}</td>
                <td class="text-xs-left">{{row.item.fund}}</td>
                <td class="text-xs-left">{{row.item.acctNoSfx}}</td>
                <td class="text-xs-left">{{row.item.description}}</td>
                <td class="text-xs-center">
                  <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr></template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      labels: {
        branch: 'Branch',
        glacctNo: 'GL Account No.',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        description: 'Description'
      },
      filters: {
        branch: null,
        glacctNo: null,
        fund: null,
        acctNoSfx: null,
        description: null
      },
      headers: [
        { text: 'Branch', value: 'branch' },
        { text: 'GL Account No.', value: 'glacctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Account No. Suffix', value: 'acctNoSfx' },
        { text: 'Description', value: 'description' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.apiURI
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map(glacctNo => {
                const convertList = {
                  branch: glacctNo.branch,
                  glacctNo: glacctNo.glacctNo,
                  fund: glacctNo.fund,
                  acctNoSfx: glacctNo.acctNoSfx,
                  description: glacctNo.description
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doFilters() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.branch = null
      this.filters.glacctNo = null
      this.filters.fund = null
      this.filters.acctNoSfx = null
      this.fetchData(false)
    },
    doSelect(data) {
      const commit = {
        primaryKey: this.primaryKey,
        data
      }
      this.$emit('selectGlAcctNo', commit)
    }
  },
  computed: {

  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    apiURI: {
      type: String,
      required: true
    },
    primaryKey: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
</style>
